import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import * as moment from 'moment';
import { ParametrosSolitudServiciosEntity, ReporteFormulasMedicasFiltro }
  from 'src/app/services/servicio-solicitud-servicios.service';
import { ImagesService } from 'src/app/services/utils/images.service';
import {
  ServicioSolitudServiciosService,
  DatosGeneralesEntity,
  FormulaMedicaEntity
} from 'src/app/services/servicio-solicitud-servicios.service';
import {
  EntidadEmpresarialEntity,
  ServicioEntidadService
} from 'src/app/services/servicio-entidad.service';

@Component({
  selector: 'app-formulas-medicas-hc',
  templateUrl: './formulas-medicas-hc.component.html',
  styleUrls: ['./formulas-medicas-hc.component.css']
})
export class FormulasMedicasHcComponent implements OnInit {

  parametros: ParametrosSolitudServiciosEntity = {} as ParametrosSolitudServiciosEntity;
  filtros: ReporteFormulasMedicasFiltro = {} as ReporteFormulasMedicasFiltro;
  mensajeLoading: string = 'Cargando...';
  mensajeError: string;
  logo: string;

  entidadEmpresarial: EntidadEmpresarialEntity;
  datosGenerales: DatosGeneralesEntity;

  formulasAgrupadas: FormulaMedicaEntity[][] = [[]];

  constructor(private activatedRoute: ActivatedRoute,
    private servicioImagenes: ImagesService,
    private servicioEntidad: ServicioEntidadService,
    private servicioSolicitudServ: ServicioSolitudServiciosService
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.parametros.codigo = params['codigoBaseDatos'];
      this.parametros.uncoSede = Number(params['uncoSede']);
      this.parametros.uncoLogin = Number(params['uncoLogin']);
      this.parametros.unco = Number(params['uncoHistoria']);
    });
  }

  ngOnInit() { }

  async getEntidadEmpresarial() {
    try {
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.parametros.codigo, this.parametros.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        if (data && data.length > 0) {
          this.entidadEmpresarial = data[0];
          this.getDatosGenerales();
        } else {
          this.onError('No se pudo cargar la información de la entidad empresarial. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error FormulasMedicasHC.getEntidadEmpresarial()', err);
        this.onError('Error al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch FormulasMedicasHC.getEntidadEmpresarial()', e);
      this.onError('Error grave al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  async getLogo() {
    try {
      this.logo = '';
      this.mensajeLoading = 'Cargando información del logo entidad ...';
      const response = await this.servicioImagenes.getLogo(this.parametros.codigo);
      response.subscribe((data: any) => {
        this.logo = data.source;
        this.getEntidadEmpresarial();
      }, (err: HttpErrorResponse) => {
        console.error('Error FormulasMedicasHC.getLogo()', err);
        this.onError('Error al obtener información del logo entidad, verifique su conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch FormulasMedicasHC.getLogo()', e);
      this.onError('Error grave al obtener información del logo entidad, intente de nuevo o reporte caso al administrador.');
    }
  }

  async getDatosGenerales() {
    try {
      this.mensajeLoading = 'Cargando información del afiliado...';
      const response = await this.servicioSolicitudServ.getDatosGenerales(this.parametros);
      response.subscribe((data: any) => {
        const result = data['data'];

        // if (data['#result-set-1'] === undefined) {
        //   this.onError('No se pudo cargar la información del paciente.');
        //   return;
        // }
        // const result = data['#result-set-1'];

        if (result.length > 0) {
          this.datosGenerales = this.servicioSolicitudServ.getDatosGeneralesEntity(result);
          this.getFormulas();
        } else {
          this.onError('No se pudo cargar la información del paciente.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error FormulasMedicasHC.getDatosGenerales()', err);
        this.onError('Error al obtener información del paciente, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch FormulasMedicasHC.getDatosGenerales()', e);
      this.onError('Error al obtener información del paciente, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  async getFormulas() {
    try {
      this.mensajeLoading = 'Cargando información de formulas medicas ...';
      const response = await this.servicioSolicitudServ.getFormulasMedicas(this.parametros, this.filtros);
      response.subscribe((data: any) => {
        const result = data['data'];
        if (result) {
          if (this.filtros.discriminarNoPos) {
            this.formulasAgrupadas = result.reduce((prev, current) => {
              for (let index = 0; index < prev.length; index++) {
                if (prev[index][0]['tipoSuministro'] === current['tipoSuministro']) {
                  prev[index].push(current);
                  return prev;
                }
              }
              prev.push([current]);
              return prev;
            }, []);
          } else {
            this.formulasAgrupadas = [result];
          }
          this.mensajeLoading = null;
          this.mensajeError = null;
        } else {
          this.onError('No fue posible cargar las fórmulas medicas. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error FormulasMedicasHC.getFormulas()', err);
        this.onError('Error al obtener información las fórmulas medicas, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch FormulasMedicasHC.getFormulas()', e);
      this.onError('Error grave al obtener información las fórmulas medicas, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  onFiltrosCompletados(filtros: ReporteFormulasMedicasFiltro) {
    this.filtros = filtros;
    this.getLogo();
  }

  onErrorGenerado(mensajeError: string) {
    this.mensajeError = mensajeError;
  }

  getFechaValidez(index: number) {
    if (this.formulasAgrupadas[index].length > 0) {
      const fecha = moment(this.filtros.fechaOrden, 'YYYY-MM-DD')
        .add(this.formulasAgrupadas[index][0].diasValidez, 'days');
      return fecha.format('YYYY-MM-DD');
    }
    return '';
  }

  getConsecutivoFormulaMedica(index: number) {
    let result = this.formulasAgrupadas[index].reduce((prev, current) => {
      return prev + current.consecutivoFormula
    }, 0);
    return result;
  }

  getDescripcionDiagnostico(tipoDiagnostico: 'Dx' | 'Dx1' | 'Dx2', index: number) {
    let descripcion = '';
    if (this.formulasAgrupadas[index].length > 0) {
      const formula = this.formulasAgrupadas[index][0];
      if (formula[`activaDescripcion${tipoDiagnostico}`]) {
        descripcion = formula[`diagnostico${tipoDiagnostico.substr(2, 2)}`]
      } else {
        const codigo = formula[`codigo${tipoDiagnostico}`];
        if (codigo !== null && codigo.trim().length > 0) {
          descripcion = `(${codigo})`
        }
      }
    }
    return descripcion;
  }

  onError(msj) {
    this.entidadEmpresarial = null;
    this.mensajeLoading = null;
    this.mensajeError = msj;
  }

  isLoading(): boolean {
    return this.mensajeLoading && this.mensajeLoading.length > 0
      && !this.isError();
  }

  isError(): boolean {
    return this.mensajeError && this.mensajeError.length > 0;
  }

  isReady(): boolean {
    return !this.isLoading() && !this.isError();
  }
}
